import PropTypes from "prop-types"
import AutoSuggest from "../Input/AutoSuggest"
import { AnchorCheckbox } from "@tryg/react-ui-library"
import { useState, useEffect } from 'preact/hooks';
import { compose } from 'recompose';
import { connect } from 'react-redux';
// Utils
import { userDataChangeAction } from '../../../actions/UserData';
import { callService } from "../../../utilities/api/service";
import { replaceAll } from '../../../utilities/common';

const TerminateInsurance = ({
  values,
  setValues,
  dispatch,
  userData,
  options,
  translations,
  onBlur,
  inputPlaceholder,
  inputLabel
}) => {

  const initialShowField = options.reduce((acc, item) => {
    acc[item.name] = false;
    return acc
  }, {})

  const [showField, setShowField] = useState(initialShowField)

  const handleTermination = (event, insurance) => {

    setShowField((prev) => ({
      ...prev,
      [insurance]: event.detail.checked
    }));

    const selected = options.find( option => option.name === insurance );
    const actions = selected.actions.find( action => action.actionType === "changeUserData" )?.props?.fields;
    dispatch(userDataChangeAction({
      fields: [
        {
          field: event.target.id,
          value: event.detail.checked,
        },
        ...actions
      ]
    }));

  }

  const getActivationDate = (companyInsured, existingInsurance, selectedInsurance, forProduct) => {
    //call activision date or dates based on condition.
    if(userData[companyInsured]) {
      if(!userData[existingInsurance] && userData[selectedInsurance]) {
        let params = [
          {
            "field": "policyID",
            "required": true
          }
        ]
        callService("getActivationDate", params, forProduct, values, dispatch);
      } else if (userData[existingInsurance] && userData[selectedInsurance]) {
        callService("getActivationDates", [], forProduct, values, dispatch);
      }
    }
  }

  useEffect(() => {
    getActivationDate(
      "indboCompanyInsured",
      "indbo_Existing_insurance",
      "indboInsurance",
      "household"
    );
  }, [userData.indbo_Existing_insurance]);

  useEffect(() => {
    getActivationDate(
      "rejseCompanyInsured",
      "rejse_Existing_insurance",
      "rejseInsurance",
      "travel"
    );
  }, [userData.rejse_Existing_insurance]);

  useEffect(() => {
    getActivationDate(
      "personCompanyInsured",
      "person_Existing_insurance",
      "personInsurance",
      "personal"
    );
  }, [userData.person_Existing_insurance]);

  useEffect(async () => {
    if(userData.otherCompanyInsured === "no-start-date-message" 
      && !userData.terminateAnyInsurance) {
        let params = [
          {
            "field": "policyID",
            "required": true
          }
        ];
        await callService("getActivationDate", params, "household", values, dispatch); 
        await callService("getActivationDate", params, "travel", values, dispatch); 
        await callService("getActivationDate", params, "personal", values, dispatch); 
    }
  }, [userData.otherCompanyInsured]);

  return (
    <div>
        {options.map((item) => {
          const insurance = item.name
          const forLabel = item.forLabel ? replaceAll(inputLabel, translations, values).replaceAll("#", item.forLabel)
                            : inputLabel;
          return(
            <>
              {userData[insurance] && 
                <AnchorCheckbox id={item.id} key={item.name} onToggled={(e) => handleTermination(e, item.name)}>
                  {item.option}
                </AnchorCheckbox>
              }
              {(showField[insurance]) && 
                <div className="combined-fina-autosuggest_field">
                  <AutoSuggest 
                    variant={"insuranceCompanies"} 
                    label={forLabel} 
                    placeholder={inputPlaceholder} 
                    id={item.autouggestId}
                    values={values}
                    setValues={setValues}
                    dispatch={dispatch}
                    userData={userData}
                    errors={{}}
                    touched={{}}
                    required={true}
                    columns={12}
                    subType={"text"}
                    successIcon={"checkmark"}
                    tarnslations={translations}
                    onBlur={onBlur}
                  />
                </div>
              }
            </>
        )})}
    </div>
  )
}

export default compose(
  connect(state => {
    const {
      userData,
      section: {
        packageData: { translations },
      },
      app: { error, errorData },
    } = state;

    return { userData, translations, error, errorData };
  })
)(TerminateInsurance);

TerminateInsurance.propTypes = {
  userData: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
  setValues: PropTypes.func.isRequired,
  options: PropTypes.array,
  translations: PropTypes.object.isRequired,
  inputPlaceholder: PropTypes.string.isRequired
}